import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useReferral, useReferralIdByPatient } from '@/hooks/useReferrals';
import { ReferralSagsakterTab } from '@/components/referrals/ReferralSagsakterTab';
import { ErrorAlert } from '@/components/ui/ErrorAlert';

interface PatientReferralSagsakterTabProps {
  patientId: string;
}

/** Same Sagsakter (NPU) checklist as referral detail, for accepted-referral patients. */
export function PatientReferralSagsakterTab({ patientId }: PatientReferralSagsakterTabProps) {
  const { t } = useTranslation();
  const {
    data: referralId,
    isLoading: idLoading,
    error: idError,
  } = useReferralIdByPatient(patientId);
  const {
    data: referral,
    isLoading: referralLoading,
    error: referralError,
  } = useReferral(referralId);

  if (idLoading || (referralId && referralLoading)) {
    return (
      <div className="flex items-center justify-center py-16">
        <Loader2 className="h-6 w-6 animate-spin text-ds-muted" />
      </div>
    );
  }

  if (idError || referralError) {
    return <ErrorAlert message={t('patients.sagsakter_load_error')} />;
  }

  if (!referralId || !referral) {
    return (
      <div className="rounded-lg border border-ds-line bg-ds-card p-6 shadow-card">
        <p className="text-sm text-ds-muted">
          {t('patients.sagsakter_no_referral')}
        </p>
      </div>
    );
  }

  return <ReferralSagsakterTab referral={referral} />;
}
